import GhostProbe from './GhostProbe';
import { Matrix3, Vector3 } from 'three';
import create from 'zustand';

export const useHoveringGhostProbe = create(set => ({
  ghostGroup: null,
  setGhostGroup: (ghostGroup) => set({ ghostGroup }),

  ghostProbe: {
    show: false
  },
  showGhostProbe: (pt,n) => set({ ghostProbe: { position: pt, normal: n, show: true }}),
  hideGhostProbe: () => set({ ghostProbe: { show: false }}) 
}));

export function HoveringGhostProbe(props) {
  const {
    toolDirection = { X: 0, Y: 0, Z: 1 },
    alignToNormal,
    show,
    children
  } = props;

  const {
    ghostGroup,
    setGhostGroup,
    ghostProbe,
    showGhostProbe,
    hideGhostProbe
  } = useHoveringGhostProbe();

  const pointerOverHandler = (hit) => {
    if(ghostGroup) {
      const n = hit.intersections[0].face.normal;
      const obj = hit.intersections[0].object;
      const p = hit.intersections[0].point;

      const mat = ghostGroup.matrixWorld.clone().invert(); // mat is world2part matrix

      const newP = p.clone().applyMatrix4(mat);

      const object2part = obj.matrixWorld.clone().premultiply(mat);
      const normMat = new Matrix3();
      normMat.getNormalMatrix(object2part);

      const newN = n.clone().applyNormalMatrix(normMat);

      newP.x += newN.x*2./25.4;
      newP.y += newN.y*2./25.4;
      newP.z += newN.z*2./25.4;

      if(alignToNormal) {
        showGhostProbe(newP, newN);
      } else {
        showGhostProbe(newP,new Vector3(toolDirection.X, toolDirection.Y, toolDirection.Z));
      }
    }
  };

  const pointerOutHandler = (e) => {
    hideGhostProbe();
  };

  return <group ref={setGhostGroup} onPointerMove={pointerOverHandler} onPointerOut={pointerOutHandler}>
    { show ? <GhostProbe {...ghostProbe}/> : null }
    {children}
  </group>;
};

export default HoveringGhostProbe;
